<style scoped lang="scss">
$border-color: rgb(218, 218, 218);
$border-color-lighter: rgb(236, 236, 236);
.log{
  box-shadow: rgba(49, 49, 49, 0.1) 0px 1px 2px 0px;
  margin-bottom: 20px;
  border: 1px solid $border-color;
  border-radius: 4px;

  &__body{
    padding: 10px 20px;
    border-top: 1px solid $border-color;
  }
  &__header{
    display: flex;
    padding: 10px 20px;
    
  }

  & table{
    font-family: 'Manrope';
    font-size: 12px;
    width: 100%;
    & tr:not(:last-child){
      border-bottom: 1px dashed $border-color-lighter;
    }
    & th{
      font-weight: 600 !important;
    }
    & th, & td{
      padding: 5px 10px;
      font-weight: 500;
      vertical-align: top;
    }
  }
}

#submission-detail{
  box-shadow: rgba(46, 46, 60, 0.1) 0px 0px 16px;
}
</style>
<template>
  <div id="sds-submission-list" class="content content--borderless">
    <div class="content__header">
      <div class="content__main-header">
        <div class="content__title">
          <div class="content__title__name">Detil Usulan {{form.submission_type == 'NEW' ? 'Baru':'Pemutakhiran'}} &nbsp;
            <span class="text-primary">{{form.sds_type == 'CONCEPT' ? 'Konsep':(form.sds_type == 'VARIABLE' ? 'Variabel':'Indikator')}}</span>  </div>
          <div class="content__title__description">Berisikan semua informasi tentang usulan yang diajukan sampai hubungan antara konsep/variabel yang digunakan.</div>
        </div>
        <div class="ml-auto d-flex">
          <b-button 
            type="button" class=" ml-2 button button--action--edit2 button--action" 
            :to="'/old-sds/edit-usulan/'+sdsItemId" :disabled="!deleteable">
            <VueFeather type="edit-3" size="14"></VueFeather>
          </b-button>
          <b-button 
            type="button" class=" ml-2 button button--action--delete2 button--action" 
            v-on:click="()=>{deletedSdsItemId = sdsItemId;$bvModal.show('modal-delete')}"  :disabled="!deleteable">
            <VueFeather type="trash" size="14"></VueFeather>
          </b-button>
        </div>
      </div>
      <div class="tab-control" style="margin-left:0px;margin-right:0px">
        <div :class="tab.index == index ? 'tab-control__item tab-control__item--active':'tab-control__item'" 
          v-for="(item,index) in tab.items" :key="index" @click="tabChange(index)">
          <div class="tab-control__item__name">{{item.name}}</div>
        </div>
      </div>
    </div>
    <div class="content__body">
      <div id="submission-detail" class="my-4" v-show="tab.index==0">
        <div v-if="form.sds_type == 'CONCEPT'">
          <b-table-simple class="table--stacked table--stacked--primary">
            <b-tbody>
              <b-tr>
                <b-th class="w-101">Nama</b-th>
                <b-td>{{concept.name}}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Definisi</b-th>
                <b-td>{{concept.definition}}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Referensi</b-th>
                <b-td>
                  <div v-for="(item,index) in concept.references" :key="index">
                    <span v-if="concept.references.length>1">{{index+1}}. </span>{{item}}
                  </div>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>
        <div v-if="form.sds_type == 'VARIABLE'">
          <b-table-simple class="table--stacked table--stacked--primary">
            <b-tbody>
              <b-tr>
                <b-th class="w-101">Nama</b-th>
                <b-td>{{variable.name}}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Definisi</b-th>
                <b-td>{{variable.definition}}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Konsep</b-th>
                <b-td style="padding:0px !important">
                  <b-table-simple class="table--borderless table--light">
                    <b-thead>
                      <tr>
                        <th style="background:none" class="w-51">No</th>
                        <th class="text-left" style="background:none">Nama</th>
                        <th class="text-left" style="background:none">Definisi</th>
                        <th style="background:none">Status</th>
                      </tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr v-for="(concept,index) in variableConcepts" :key="index">
                        <b-td class="text-center">{{index+1}}</b-td>
                        <b-td>{{concept.name}}</b-td>
                        <b-td>{{concept.definition}}</b-td>
                        <b-td class="text-center text-nowrap">
                          <span :class="'status status--'+statusFormatterStyle(concept.status)">{{statusFormatter(concept.status)}}</span>
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </b-td>
              </b-tr>
              <b-tr>
                <b-th>Unit Observasi</b-th>
                <b-td>
                  <div v-for="(item,index) in variable.unit_types" :key="index" class="d-flex">
                    <div v-if="variable.unit_types.length>1" class="w-20">{{index+1}}.</div>
                    <div>{{item.name}}</div>
                  </div>
                </b-td>
              </b-tr>
              <b-tr>
                <b-th>Ukuran</b-th>
                <b-td>{{variable.measurement ? variable.measurement.name: '-'}}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Satuan</b-th>
                <b-td>{{variable.measurement_unit ? variable.measurement_unit.name: '-'}}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Subjek</b-th>
                <b-td>{{variable.subject_field ? variable.subject_field.name: '-'}}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Value Domain</b-th>
                <b-td style="padding:0px !important">
                  <div class="d-flex" style="padding:7px 10px 5px 10px;">
                    <div class="w-120 text-semi-bold text-12" style="color:teal">Jenis value domain</div>
                    <div class="text-center w-20">:</div>
                    <div>{{variable.value_domain.type.id == 76 ? 'Kategori':'Non Kategori'}}</div>
                  </div>
                  <div class="d-flex" style="padding:0px 10px 10px 10px; border-bottom:1px solid #BDBDBD" v-if="variable.value_domain.type.id == 76 ">
                    <div class="w-120 text-semi-bold text-12" style="color:teal">Referensi klasifikasi</div>
                    <div class="text-center w-20">:</div>
                    <div>{{variable.value_domain.classification_reference? variable.value_domain.classification_reference:'Tidak menggunakan'}}</div>
                  </div>
                  <b-table-simple class="table--borderless table--light" v-if="variable.value_domain.type.id == 76 ">
                    <b-thead>
                      <tr>
                        <th class="text-center w-60" style="background:none">Kode</th>
                        <th class="text-left w-30p" style="background:none">Nama</th>
                        <th class="text-left" style="background:none">Deskripsi</th>
                      </tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr v-for="(item,index) in variable.value_domain.items" :key="index">
                        <b-td class="text-center" >{{item.code}}</b-td>
                        <b-td>{{item.name}}</b-td>
                        <b-td>{{item.description ? item.description  :'-'}}</b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </b-td>
              </b-tr>
              <b-tr>
                <b-th>Referensi</b-th>
                <b-td>
                  <div v-for="(item,index) in variable.references" :key="index" class="d-flex">
                    <div v-if="variable.references.length>1" class="w-20">{{index+1}}.</div>
                    <div>{{item}}</div>
                  </div>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </div>
        <div v-if="form.sds_type == 'INDICATOR'">
          <b-table-simple class="table--stacked table--stacked--primary">
            <b-tbody>
              <b-tr>
                <b-th class="w-101">Nama</b-th>
                <b-td>{{indicator.name}}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Definisi</b-th>
                <b-td>{{indicator.definition}}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Konsep</b-th>
                <b-td style="padding:0px !important">
                  <b-table-simple class="table--borderless table--light">
                    <b-thead>
                      <tr>
                        <th style="background:none" class="w-51">No</th>
                        <th class="text-left" style="background:none">Nama</th>
                        <th class="text-left" style="background:none">Definisi</th>
                        <th style="background:none">Status</th>
                      </tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr v-for="(concept,index) in indicatorConcepts" :key="index">
                        <b-td class="text-center">{{index+1}}</b-td>
                        <b-td>{{concept.name}}</b-td>
                        <b-td>{{concept.definition}}</b-td>
                        <b-td class="text-center text-nowrap">
                          <span :class="'status status--'+statusFormatterStyle(concept.status)">{{statusFormatter(concept.status)}}</span>
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </b-td>
              </b-tr>
              <b-tr>
                <b-th>Ukuran</b-th>
                <b-td>{{indicator.measurement ? indicator.measurement.name: '-'}}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Satuan</b-th>
                <b-td>{{indicator.measurement_unit ? indicator.measurement_unit.name: '-'}}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Subjek</b-th>
                <b-td>{{indicator.subject_field ? indicator.subject_field.name: '-'}}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Manfaat</b-th>
                <b-td>{{indicator.benefit ? indicator.benefit: '-'}}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Interpretasi</b-th>
                <b-td>{{indicator.interpretation ? indicator.interpretation: '-'}}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Level terkecil tersedianya data</b-th>
                <b-td>
                  <div v-for="(item,index) in indicator.presentation_levels" :key="index" class="d-flex">
                    <div v-if="indicator.presentation_levels.length>1" class="w-20">{{index+1}}.</div>
                    <div>{{item.name}}</div>
                  </div>
                </b-td>
              </b-tr>
              <b-tr>
                <b-th>Mekanisme Perhitungan</b-th>
                <b-td>{{indicator.calculation_mechanism ? indicator.calculation_mechanism : '-'}}</b-td>
              </b-tr>
              <b-tr>
                <b-th>Rumus</b-th>
                <b-td>
                  <EquationViewer :value="indicator.formula ? indicator.formula : '-'"></EquationViewer>
                  <div class="mt-2 equation-structure" v-if="indicator.formula">
                    <div class="i-text-field-name" style="color:teal">Keterangan:</div>
                    <b-table-simple class="table table--form">
                      <b-tbody>
                        <b-tr v-for="(item,index) in indicator.formula_structures" :key="index">
                          <b-td :style="item.symbol && item.symbol.length<6 ? 'width:1px;white-space:nowrap ':''" style="border:none !important;padding:0px 1px !important">
                            <EquationViewer :value="item.symbol? item.symbol : '-'"></EquationViewer>
                          </b-td>
                          <b-td style="vertical-align:middle;border:none !important;padding:0px 5px !important">
                            : &nbsp; {{item.description}}
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                  </div>
                </b-td>
              </b-tr>
              <b-tr>
                <b-th>Disaggregasi</b-th>
                <b-td style="padding:0px !important" v-if="indicatorDisaggregations.length>0">
                  <b-table-simple class="table--borderless table--light" >
                    <b-thead>
                      <tr>
                        <th style="background:none" class="w-51">No</th>
                        <th class="text-left" style="background:none">Nama</th>
                        <th class="text-left" style="background:none">Definisi</th>
                        <th style="background:none">Status</th>
                      </tr>
                    </b-thead>
                    <b-tbody>
                      <b-tr v-for="(disaggregation,index) in indicatorDisaggregations" :key="index">
                        <b-td class="text-center">{{index+1}}</b-td>
                        <b-td>{{disaggregation.name}}</b-td>
                        <b-td>{{disaggregation.definition}}</b-td>
                        <b-td class="text-center text-nowrap">
                          <span :class="'status status--'+statusFormatterStyle(disaggregation.status)">{{statusFormatter(disaggregation.status)}}</span>
                        </b-td>
                      </b-tr>
                    </b-tbody>
                  </b-table-simple>
                </b-td>
                <b-td v-else>-</b-td>
              </b-tr>
              <b-tr>
                <b-th>Referensi</b-th>
                <b-td>
                  <div v-for="(item,index) in indicator.references" :key="index" class="d-flex">
                    <div v-if="indicator.references.length>1" class="w-20">{{index+1}}.</div>
                    <div>{{item}}</div>
                  </div>
                </b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
          
        </div>
      </div>
      <div id="submission-log" class="my-4 mx-0" v-show="tab.index==1">
        <div v-for="(item, index) in sdsItemHistories" :key="index">
          <div class="log" v-if="item.data">
            <div class="log__header" >
              <div>
                <div :class="'status status--'+statusFormatterStyle(item.status)">
                  {{statusFormatter(item.status)}}
                </div>
              </div>
              <div class="ml-auto text-13 d-flex align-items-center">
                {{dateFormatter(item.created_at)}} <VueFeather type="chevron-down" size="14" style="display:block; margin-left:10px"></VueFeather>
              </div>
            </div>
            <div class="log__body">
              <div v-if="form.sds_type == 'CONCEPT'">
                <table>
                  <tr>
                    <th>Nama</th>
                    <td>{{item.data.concept.name}}</td>
                  </tr>
                  <tr>
                    <th>Definisi</th>
                    <td>{{item.data.concept.definition}}</td>
                  </tr>
                </table>
              </div>
              <div v-if="form.sds_type == 'VARIABLE'">
                <table>
                  <tr>
                    <th>Nama</th>
                    <td>{{item.data.variable.name}}</td>
                  </tr>
                  <tr>
                    <th>Definisi</th>
                    <td>{{item.data.variable.definition}}</td>
                  </tr>
                </table>
              </div>
              <div v-if="form.sds_type == 'INDICATOR'">
                <table>
                  <tr>
                    <th>Nama</th>
                    <td>{{item.data.indicator.name}}</td>
                  </tr>
                  <tr>
                    <th>Definisi</th>
                    <td>{{item.data.indicator.definition}}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div v-if="sdsItemHistories.length<1" class="alert alert--warning align-items-end">
          <div class="alert__icon pt-1 pr-1">
            <VueFeather type="alert-triangle" size="20" style="display:block"></VueFeather>
          </div>
          <div class="alert__value">
            <div class="text-14">
              Maaf Log pengusulan belum tersedia
            </div>
          </div>
        </div>
        

      </div>
    </div>
    <b-modal  hide-header hide-footer id="modal-delete" size="sm" content-class="modal--confirmation text-center" >
        <div class="p-3 text-danger" >
          <div >
            <VueFeather type="x-circle" size="60" stroke-width="2" stroke="#ff0055"></VueFeather>
          </div>
          <div class="text-center mt-2" style="font-size:16px;font-weight:600;color:#ff0055;">
            Apakah anda yakin menghapus item ini?
          </div>
          <div class="mt-1" style="color:#2e2e2e;font-weight:500;opacity:0.8;font-size:13px;letter-spacing:.2px">
            Ketika dihapus, item tidak bisa dikembalikan lagi, kecuali anda melakukan input ulang
          </div>
        </div>
        <div class="mt-3 mb-2">
          <b-button class="i-button mr-2" 
            v-on:click="()=>{$bvModal.hide('modal-delete');}"
          >Batal</b-button>
          <b-button class="i-button i-button-danger" 
            v-on:click="deleteSdsItem"
          >Hapus</b-button>
        </div>
    </b-modal>
  </div>
</template>

<script>
import "@/assets/scss/indah.scss";
import "@/assets/scss/main.scss";
import "@/assets/scss/treeselect.scss";
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import moment from 'moment';
import VueFeather from 'vue-feather';
import EquationViewer from "../../../components/equation/EquationViewer";
import SdsService from "../../../services/SdsService";
import store from "../../../store";
import SubjectField from '../data/subject_field.js';

export default{
  components:{
    EquationViewer,
    VueFeather,
  },
  data() {
    return {
      sdsItem: null,
      sdsItemId: null,
      sdsItemHistories: null,
      deletedSdsItemId:null,
      tab:{
        index:0,
        items:[
          {
            name:'Detil Usulan',
            count : 0,
          },
          {
            name:'Log Pengusulan',
            count : 0,
          },
        ]
      },
      
      user:null,
      userRoles:[],
      concept: null,
      variable: null,
      variableConcepts:[],
      indicator: null,
      indicatorConcepts:[],
      indicatorDisaggregations:[],
      form: {
        data: {
          concept: null,
          variable: null,
          indicator: null,
        },
        submission_period: null,
        submission_type: null,
        sds_type: null,
        status: null,
        rejection_note: null,
        alternative_sds_item_id: null,
        submitter: null,
        produsen_data: null,
        walidata_pusat: null,
        reviews:[],
      },
      options:{
        submissionType:[
          {value:'NEW', text:'Baru'},
          {value:'UPDATE', text:'Pemutakhiran'},
        ],
        sdsType:[
          {value:'CONCEPT', text:'Konsep'},
          {value:'VARIABLE', text:'Variabel'},
          {value:'INDICATOR', text:'Indikator'},
        ],
        statusTree:[
          {id: 'KabupatenKota', label:'Kabupaten/Kota',children:[
            {id:'DRAFT_KABKOTA', label:'Draft Produsen Data'},
            {id:'SUBMITTED_KABKOTA', label:'Submit Produsen Data'},
            {id:'REVIEW_KABKOTA', label:'Diperiksa Walidata Kabupaten/Kota'},
            {id:'CORRECTION_KABKOTA', label:'Perbaikan Produsen Data'},
            {id:'PENDING_KABKOTA', label:'Ditunda Walidata'},
            {id:'REJECTED_KABKOTA', label:'Ditolak Walidata'},
            {id:'APPROVED_KABKOTA', label:'Diterima Walidata'},
          ]},
          {id: 'Provinsi', label:'Provinsi',children:[
            {id:'DRAFT_PROVINSI', label:'Draft Produsen Data'},
            {id:'SUBMITTED_PROVINSI', label:'Submit Produsen'},
            {id:'REVIEW_PROVINSI', label:'Diperiksa Walidata Provinsi'},
            {id:'CORRECTION_PROVINSI', label:'Perbaikan Produsen Data & Walidata'},
            {id:'REJECTED_PROVINSI', label:'Ditolak Walidata'},
            {id:'APPROVED_PROVINSI', label:'Diterima Walidata'},
            {id:'PENDING_PROVINSI', label:'Ditunda Walidata'},
          ]},
          {id: 'Pusat', label:'Pusat',children:[
            {id:'DRAFT_PUSAT', label:'Draft Produsen Data'},
            {id:'SUBMITTED_PUSAT', label:'Submit Produsen Data'},
            {id:'REVIEW_PUSAT', label:'Diperiksa Walidata Pusat'},
            {id:'CORRECTION_PUSAT', label:'Perbaikan Produsen Data & Walidata'},
            {id:'REJECTED_PUSAT', label:'Ditolak Walidata'},
            {id:'APPROVED_PUSAT', label:'Diterima Walidata'},
            {id:'PENDING_PUSAT', label:'Ditunda Walidata'},
            {id:'PUBLISHED_PUSAT', label:'Publish'},
          ]},
        ],
        status:[
          {value:'DRAFT_KABKOTA', label:'Draft Produsen Data Kabupaten/Kota'},
          {value:'SUBMITTED_KABKOTA', label:'Submit Produsen Data Kabupaten/Kota'},
          {value:'REVIEW_KABKOTA', label:'Diperiksa Walidata Kabupaten/Kota'},
          {value:'CORRECTION_KABKOTA', label:'Perbaikan Produsen Data & Walidata Kabupaten/Kota'},
          {value:'PENDING_KABKOTA', label:'Ditunda Walidata Kabupaten/Kota'},
          {value:'REJECTED_KABKOTA', label:'Ditolak Walidata Kabupaten/Kota'},
          {value:'APPROVED_KABKOTA', label:'Diterima Walidata Kabupaten/Kota'},

          {value:'DRAFT_PROVINSI', label:'Draft Produsen Data Provinsi'},
          {value:'SUBMITTED_PROVINSI', label:'Submit Produsen Data Provinsi'},
          {value:'REVIEW_PROVINSI', label:'Diperiksa Walidata Provinsi'},
          {value:'CORRECTION_PROVINSI', label:'Perbaikan Produsen Data & Walidata Provinsi'},
          {value:'REJECTED_PROVINSI', label:'Ditolak Walidata Provinsi'},
          {value:'APPROVED_PROVINSI', label:'Diterima Walidata Provinsi'},
          {value:'PENDING_PROVINSI', label:'Ditunda Walidata Provinsi'},

          {value:'DRAFT_PUSAT', label:'Draft Produsen Data Pusat'},
          {value:'SUBMITTED_PUSAT', label:'Submit Produsen Data Pusat'},
          {value:'REVIEW_PUSAT', label:'Diperiksa Walidata Pusat'},
          {value:'CORRECTION_PUSAT', label:'Perbaikan Produsen Data & Walidata Pusat'},
          {value:'REJECTED_PUSAT', label:'Ditolak Walidata Pusat'},
          {value:'APPROVED_PUSAT', label:'Diterima Walidata Pusat'},
          {value:'PENDING_PUSAT', label:'Ditunda Walidata Pusat'},
          {value:'PUBLISHED_PUSAT', label:'Publish'},
        ],
        subjectField : [],
        requester:[],
        organization:[],
        value_domain_type:[
          { value: { id: 75, name: 'Described Value Domain', description:'Jenis value domain yang nilai dinyatakan dalam bentuk ekspresi atau deskripsi' }, text: 'Non Kategori',},
          { value: { id: 76, name: 'Enumerated Value Domain', description: 'Jenis value domain yang nilai dinyatakan sebagai daftar kode dan kategori' }, text: 'Kategori' },
        ],
        presentation_level:[
          { value: { id: 148, name: 'Nasional', description: null}, text: 'Nasional'},
          { value: { id: 149, name: 'Provinsi', description: null}, text: 'Provinsi'},
          { value: { id: 150, name: 'Kabupaten/Kota', description: null}, text: 'Kabupaten/Kota'},
          { value: { id: 151, name: 'Kecamatan', description: null}, text: 'Kecamatan'},
          { value: { id: 152, name: 'Kelurahan/Desa', description: null}, text: 'Kelurahan/Desa'}
        ],
        concept:[],
        variable:[],
        unit_type:[],
        measurement:[],
        measurement_unit:[],
        classification_series:[],
        statistical_classification:[],
        statistical_classification_level:[],
      },
    }
  },
  watch:{
    'formFilter.name'(){
      this.filterSdsItemList();
    },
  },
  computed:{
    isAdmin(){
      return this.userRoles.includes("ROLE_SDS_ADMIN");
    },
    isPembinaDataPusat(){
      return this.userRoles.includes("ROLE_PEMBINA_DATA_PUSAT");
    },
    isPembinaDataProvinsi(){
      return this.userRoles.includes("ROLE_PEMBINA_DATA_PROVINSI");
    },
    isWalidata(){
      return this.userRoles.includes("ROLE_WALIDATA_PUSAT") || this.userRoles.includes("ROLE_WALIDATA_PROVINSI") || this.userRoles.includes("ROLE_WALIDATA_KABUPATEN_KOTA");
    },
    isWalidataPusat(){
      return this.userRoles.includes("ROLE_WALIDATA_PUSAT");
    },
    isWalidataProvinsi(){
      return this.userRoles.includes("ROLE_WALIDATA_PROVINSI");
    },
    isWalidataKabupatenKota(){
      return this.userRoles.includes("ROLE_WALIDATA_KABKOTA");
    },
    isProdusenData(){
      return this.userRoles.includes("ROLE_PRODUSEN_DATA_PUSAT") || this.userRoles.includes("ROLE_PRODUSEN_DATA_PROVINSI") || this.userRoles.includes("ROLE_PRODUSEN_DATA_KABKOTA");
    },
    isProdusenDataKabupatenKota(){
      return this.userRoles.includes("ROLE_PRODUSEN_DATA_KABKOTA");
    },
  },
  async mounted(){
    this.sdsItemId = this.$route.params.id;
    this.getUserInfo(store.getters["auth/user"]);
    // await this.setUpSetting();
    await this.getSdsItem(this.sdsItemId);
    if(this.form.sds_type != "CONCEPT"){
      this.syncConceptReference();
    }
    if(this.form.sds_type == "INDICATOR"){
      this.syncDisaggregationReference();
    }
  },
  methods:{
    async getSdsItem(){
      await SdsService.getSdsItem(this.sdsItemId).then(
        async (result)=>{
          this.sdsItem = {...result.data.result[0]};
          let x = this.sdsItem;
          this.form={
            data: x.data,
            submission_period: x.submission_period,
            submission_type: x.submission_type,
            sds_type: x.sds_type,
            status: x.status,
            rejection_note: x.rejection_note,
            alternative_sds_item_id: x.alternative_sds_item_id,
            rejected_similiar_item_ids:[],
            submitter: this.user,
            produsen_data: {
              id: x.produsen_data_id,
              name: x.produsen_data_name,
              province_code: x.produsen_data_province_code,
              city_code: x.produsen_data_city_code,
            },
            walidata_pusat: {
              id: x.walidata_pusat_id,
              name: x.walidata_pusat_name,
            },
            reviews:x.review ? x.review : [],
            proposed_walidata_kabupaten_kota:	false,
            proposed_walidata_provinsi:	false,
            proposed_walidata_pusat:	false,
          };
          this.produsenData = this.form.produsen_data;
          this.walidata = this.form.walidata_pusat; 
          if(this.form.sds_type == 'CONCEPT'){
            this.concept = this.form.submissionPeriod > 2022 ? this.form.data.concept : this.updateConceptStructure(this.form.data.concept, this.form.submission_type);
          }
          else if(this.form.sds_type == 'VARIABLE'){
            this.variable = this.form.submissionPeriod > 2022 ? this.form.data.variable : this.updateVariableStructure(this.form.data.variable, this.form.submission_type);
          }
          else{
            this.indicator = this.form.submissionPeriod > 2022 ? this.form.data.indicator : this.updateIndicatorStructure(this.form.data.indicator, this.form.submission_type);
          }
          this.sdsItemHistories = x.sds_item_histories;
        },
        (error)=>{
          console.log(error);
        }
      );
    },
    async syncConceptReference(){
      console.log('baka')
      if(this.form.sds_type == "VARIABLE"){
        let concepts = [...this.sdsItem.data.variable.concepts];
        this.variableConcepts = await Promise.all(concepts.map(async (item) => {
            let concept = null;
            if(this.sdsItem.submission_period==2022 && item.submission_id ){
              let id = item.submission_id;
               await SdsService.getOldSdsItem(id).then(
                (result)=>{
                  concept = {...result.data.result[0]};
                  concept.definition = concept.data.concept.definition;
                  concept.source = 'USULAN';
                  
                },
                (error)=>{
                  console.log(error);
                }
              );
            }else{
              await SdsService.getSdsItem(item.id).then(
                (result)=>{
                  concept = {...result.data.result[0]};
                  concept.definition = concept.data.concept.definition;
                  concept.source = 'USULAN';
                  
                },
                (error)=>{
                  console.log(error);
                }
              );
            }
            return concept;
        }));  
      }else{
        let concepts = [...this.indicator.concepts];
        this.indicatorConcepts = await Promise.all(concepts.map(async (item) => {
            let concept = null;
            if(this.sdsItem.submission_period==2022){
              let id = item.submission_id;
               await SdsService.getOldSdsItem(id).then(
                (result)=>{
                  concept = {...result.data.result[0]};
                  concept.definition = concept.data.concept.definition;
                  concept.source = 'USULAN';
                  
                },
                (error)=>{
                  console.log(error);
                }
              );
            }else{
              await SdsService.getSdsItem(item.id).then(
                (result)=>{
                  concept = {...result.data.result[0]};
                  concept.definition = concept.data.concept.definition;
                  concept.source = 'USULAN';
                  
                },
                (error)=>{
                  console.log(error);
                }
              );
            }
            return concept;
        })); 
      }
      
    },
    async syncDisaggregationReference(){
      let disaggregations = [...this.sdsItem.data.indicator.disaggregations].filter(x=>x != null);
      this.indicatorDisaggregations = await Promise.all(disaggregations.map(async (item) => {
        let disaggregation = null;
        if(this.sdsItem.submission_period==2022){
          let id = item.submission_id;
            await SdsService.getOldSdsItem(id).then(
            (result)=>{
              disaggregation = {...result.data.result[0]};
              disaggregation.definition = disaggregation.data.variable.definition;
              disaggregation.source = 'USULAN';
              
            },
            (error)=>{
              console.log(error);
            }
          );
        }else{
          await SdsService.getSdsItem(item.id).then(
            (result)=>{
              disaggregation = {...result.data.result[0]};
              disaggregation.definition = disaggregation.data.variable.definition;
              disaggregation.source = 'USULAN';
              
            },
            (error)=>{
              console.log(error);
            }
          );
        }
        return disaggregation;
          
      })); 
      
    },
    updateConceptStructure(concept,submissionType){
      let newConcept = {
        code: concept.code,
        name: concept.name,
        definition: concept.definition,
        references: concept.references.map(x=>typeof x == 'string' ? x : x.name),
        updated_concept: null,
      }
      if(submissionType == 'UPDATE'){
        newConcept.updated_concept = {
          changes_type : 'MODIFY', 
          items: []
        }
        if('updated_concept' in concept){
          newConcept.updated_concept = concept.updated_concept;
        }else{
          let newUpdatedConcept = concept.current_version;
          newUpdatedConcept.references = newUpdatedConcept.references.map(x=>x.name),
          
          newConcept.updated_concept = {
            changes_type : 'MODIFY', 
            items: [newUpdatedConcept]
          }
        }
      }
      return newConcept;
    },
    updateVariableStructure(variable,submissionType){
      // let submissionType = sdsItem.submission_type;
      // let variable = sdsItem.data.variable;
      // console.log(variable)
      let newVariable = {
        code: variable.code,
        name: variable.name,
        definition: variable.definition,
        concepts: ('concept' in variable) ? variable.concept : variable.concepts, //update with actual state,
        unit_types: variable.unit_types, //change format json
        measurement: variable.measurement, //change format json
        measurement_unit: variable.measurement_unit, //change format json,
        subject_field: variable.subject_field, //change format json,
        value_domain: variable.value_domain, //change format json
        rule: variable.rule,
        references: variable.references.map(x=>typeof x == 'string' ? x : x.name),
        updated_variable: null,
      }
      if(submissionType == 'UPDATE'){
        if('updated_variable' in variable){
          newVariable.updated_variable = variable.updated_variable;
        }else{
          let newUpdatedVariable = variable.current_version;
          newUpdatedVariable.references = newUpdatedVariable.references.map(x=>typeof x == 'string' ? x : x.name);
          let newValueDomain  = {
            type: null,// change use current format
            classification_reference: null,
            items:[],
            total_levels:0
          }
          if('classification' in newUpdatedVariable.value_domain){
            newValueDomain.items = newUpdatedVariable.value_domain.classification.items;
          }else{
            newValueDomain.items = newUpdatedVariable.value_domain.items;
          }
          newUpdatedVariable.value_domain = newValueDomain;

          newVariable.updated_variable = {
            changes_type : 'MODIFY', 
            items: [newUpdatedVariable]
          }
        }

      }
      //change format json for unit types 
      if(newVariable.unit_types != null & newVariable.unit_types.length>0){
        newVariable.unit_types = newVariable.unit_types.filter(x=>x!=null).map(item => {
          let _newUnitTypes = {
              id:item.id,
              name:item.name,
              description:null,
            };
          return _newUnitTypes;     
        });
      }
      //change format json for measurement 
      if(newVariable.measurement){
        let newMeasurement = {
          id:newVariable.measurement.id,
          name:newVariable.measurement.name,
          description:null,
        };
        newVariable.measurement = newMeasurement;
      }
      //change format json for measurement unit
      if(newVariable.measurement_unit){
        let newMeasurementUnit = {
          id: newVariable.measurement_unit.id,
          name: newVariable.measurement_unit.name,
          symbol: null
        }
        newVariable.measurement_unit = newMeasurementUnit;
      }
      //change format json for subject_field
      if(newVariable.subject_field){
        let subjects =  [...SubjectField]
        newVariable.subject_field = subjects.map(({id,code,name,description})=>({id,code,name,description})).find(x => x.id == newVariable.subject_field.id);
      }
      //change format json for value domain
      // console.log(newVariable.value_domain)
      if(newVariable.value_domain){
        let newValueDomain  = {
          type: null,// change use current format
          classification_reference: null,
          items:[],
          total_levels:0
        }
        if(newVariable.value_domain.type && newVariable.value_domain.type.id != null){
          newValueDomain.type = this.options.value_domain_type.map(x=> x.value).find(x => x.id == newVariable.value_domain.type.id);
          if(newValueDomain.type.id == 76){
            if('classification' in newVariable.value_domain){
              newValueDomain.classification_reference = newVariable.value_domain.classification.id ? {
                id: newVariable.value_domain.classification.id,
                name: newVariable.value_domain.classification.name,
                description: null,
                used_type: newVariable.value_domain.classification.items.length>0 ? 'PARTIAL' : 'FULL',
              } : null;
              newValueDomain.items = newVariable.value_domain.classification.items;
            }else{
              newValueDomain.classification_reference = newVariable.value_domain.classification_reference;
              newValueDomain.items = newVariable.value_domain.items;
            }
          }
        }
        newVariable.value_domain = newValueDomain;
      }
      return newVariable;
    },
    //4.1 INDICATOR
    updateIndicatorStructure(indicator,submissionType){
      // let submissionType = sdsItem.submission_type;
      // let indicator = sdsItem.data.indicator;

      let newIndicator = {
        code: indicator.code,
        name: indicator.name,
        definition: indicator.definition,
        concepts: indicator.concepts, //update with actual state,
        measurement: indicator.measurement, //change format json
        measurement_unit: indicator.measurement_unit, //change format json,
        subject_field: indicator.subject_field, //change format json,
        benefit: indicator.benefit,
        interpretation: indicator.interpretation,
        presentation_levels: indicator.presentation_levels, //change format json,
        calculation_mechanism: indicator.calculation_mechanism,
        formula: indicator.formula,
        formula_structures: indicator.formula_structures,
        disaggregations: indicator.disaggregations, //update with actual state,
        references: indicator.references.map(x=>typeof x == 'string' ? x : x.name),
        updated_indicator: null,
      }
      if(submissionType == 'UPDATE'){
        if('updated_indicator' in indicator){
          newIndicator.updated_indicator = indicator.updated_indicator;
        }else{
          let newUpdatedIndicator = indicator.current_version;
          newUpdatedIndicator.references = newUpdatedIndicator.references.map(x=>typeof x == 'string' ? x : x.name);
          newIndicator.updated_indicator = {
            changes_type : 'MODIFY', 
            items: [newUpdatedIndicator]
          }
        }
      }
      //change format json for measurement
      if(newIndicator.measurement){
        let newMeasurement = {
          id:newIndicator.measurement.id,
          name:newIndicator.measurement.name,
          description:null,
        };
        newIndicator.measurement = newMeasurement;
      }
      //change format json for measurement unit
      if(newIndicator.measurement_unit){
        let newMeasurementUnit = {
          id: newIndicator.measurement_unit.id,
          name: newIndicator.measurement_unit.name,
          symbol: null
        }
        newIndicator.measurement_unit = newMeasurementUnit;
      }
      //change format json for subject_field
      if(newIndicator.subject_field){
        let subjects =  [...SubjectField]
        newIndicator.subject_field = subjects.map(({id,code,name,description})=>({id,code,name,description})).find(x => x.id == newIndicator.subject_field.id);
      }
      //change format json for presentation levels
      if(newIndicator.presentation_levels != null & newIndicator.presentation_levels.length>0){
        //there is posibilty that there is a duplicate item, so we will remove it
        let unique = new Set();
        newIndicator.presentation_levels = newIndicator.presentation_levels.filter(obj => {
          let isPresent = unique.has(obj.id);
          unique.add(obj.id);
          return !isPresent;
        });
        
        newIndicator.presentation_levels = newIndicator.presentation_levels.map(item => {
          let z = this.options.presentation_level.map(x=> x.value).find(x => x.id == item.id);
          return z;
        });
      }
      //update variable as indicator disaggregations with actual state
      if(newIndicator.disaggregations != null & newIndicator.disaggregations.length>0){
        newIndicator.disaggregations = newIndicator.disaggregations.map(item => {
          if(item){
            if(item.submission_id){
              return this.options.variable.find(x => x.submission_id == item.submission_id);
            }else{
              return this.options.variable.find(x => x.content_id == item.id);
            } 
          }     
        });
      }
      return newIndicator;
    },
    async setUpSetting(){
      await SdsService.getSettings().then(
        (result)=>{
          this.initialSubmissionPeriod = result.data.filter(x=>x.property == 'submission_period')[0].value;
          this.submissionPeriod = this.initialSubmissionPeriod;

          if(localStorage.submissionPeriod && localStorage.submissionPeriod == this.initialSubmissionPeriod -1){
            this.submissionPeriod = localStorage.submissionPeriod;
          }
        },
        (error)=>{
          console.log(error)
        }
      )
    },
    tabChange(index){
      this.tab.index = index;
      
    },
    async deleteSdsItem(){
      await SdsService.deleteSdsItem(this.deletedSdsItemId).then(
        (result) => {
          this.$bvModal.hide('modal-delete');
          let response = result.data.result[0];
          if(response==null){
            this.delay(500).then(() => this.$router.push('/old-sds/daftar-usulan'));
          }
          else{
            if(response.status == 403){
              this.modal.error.title = 'Delete Item Gagal';
              this.modal.error.description = 'Anda hanya dapat menghapus item yang berstatus DRAFT saja';
            }
            else{
              this.modal.error.title = response.title;
              this.modal.error.description = response.detail;
            }
            this.$bvModal.show('modal-error');
          }
        },
        (error) => {
            console.log(error);
        }
      );
    },
    delay(time) {
      return new Promise(resolve => setTimeout(resolve, time));
    },
    getUserInfo(user){
      this.user = {
        username: user.username,
        name : user.name,
        email: user.email,
        organization: {
          id: user.sdiOrganization.id,
          name: user.sdiOrganization.name,
          address: user.sdiOrganization.details.address,
          province: user.sdiOrganization.details.province,
          city: user.sdiOrganization.details.city,
        } 
      }
      this.userRoles = user.role.slice(1,-1).split(", ");
      // this.form.submitter = this.user;

      this.myOrganizationId=user.sdiOrganization.id;
    },
    
    //MODAL FUNCTION
    //UTILITIES FUNCTION
    
    capitalize([first, ...rest]){
      return first.toUpperCase() + rest.join('');

    },
    dateFormatter(stringDate){
      moment.locale("id");
      return moment(stringDate).format('LL');
    },
    statusFormatter(status){
      return status ? this.options.status.find(x=>x.value == status).label : 'Draft';
    },
    statusFormatterStyle(status){
      return status ? status.split('_')[0].toLowerCase() : 'draft';
    },
    
    editable(sdsItem){
      if(['DRAFT_KABKOTA','DRAFT_PROVINSI','DRAFT_PUSAT','CORRECTION_KABKOTA','CORRECTION_PROVINSI','CORRECTION_PUSAT'].includes(sdsItem.status)){
        if(this.isAdmin || this.user.name == sdsItem.requester){
          return true;
        }else{
          if(this.user.organization.name == sdsItem.requester_organization && this.isProdusenDataSupervisor(sdsItem.status)){
            return true
          }else{
            return false
          }
        }
      }else{
        if(this.isAdmin){
          return true
        }else{
          return false
        }
      }
    },
    deleteable(sdsItem){
      if(sdsItem.status == 'DRAFT'){
        if(this.isAdmin || this.user.name == sdsItem.requester){
          return true;
        }else{
          if(this.user.organization.name == sdsItem.requester_organization && this.isProdusenDataSupervisor){
            return true
          }else{
            return false
          }
        }
      }else{
        if(this.userRoles.includes('ROLE_SDS_ADMIN')){
          return true
        }else{
          return false
        }
      }
    },
    
  }
}
</script>
